const pmsConstants = {
    USER_TYPE_PRACTICE_STRING : "Practice Administrator",
    USER_TYPE_PRACTICE : "Practice",
    USER_TYPE_STAFF_STRING : "Staff",
    USER_TYPE_STAFF : "Staff",
    USER_TYPE_PATIENT : "Patient",

    URGENCY_TYPE_URGENT_STRING: '1 to 3 days',
    URGENCY_TYPE_INTERMEDIATE_URGENT_STRING: '1 to 2 Weeks',
    URGENCY_TYPE_NON_URGENT_STRING: '> 2 Weeks',
}

export default pmsConstants;